"use strict";
exports.__esModule = true;
exports.SDK_WHAT_IS_FLEX = void 0;
exports.SDK_WHAT_IS_FLEX = {
    CTA: 'Get started',
    HEADER: 'Flexible Rent works with your property to make splitting rent easy',
    LEARN_MORE: 'Learn more',
    LIST: {
        HEADER: 'How it works',
        ITEM_1: 'Get approved for a Flex line of credit and set up your schedule',
        ITEM_2: 'Pay part of your rent up front',
        ITEM_3: 'Flex helps pay your rent in full and on time',
        ITEM_4: 'Pay Flex back later in the month'
    },
    NOTICE_1: 'By continuing, you agree to Flex’s ',
    NOTICE_2: '. Flex line of credit is issued by Lead Bank. Visit ',
    NOTICE_3: ' for more info.'
};
